export default "__VITE_ASSET__Bz9OM9WU__"